'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AVAILABILITY = {
  ALL: 'ALL',
  SP: 'SP'
};
var STATUS = {
  NONE: 'NONE',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  FINISHED: 'FINISHED',
  REFUNDED: 'REFUNDED'
};
var minImageResolution = exports.minImageResolution = {
  width: 0,
  height: 0
};
exports.default = {
  AVAILABILITY: AVAILABILITY,
  STATUS: STATUS
};